import type { SidebarSectionComponent } from "@productlane/api/src/browser"

function searchTextOf(component: SidebarSectionComponent): string {
	switch (component.type) {
		case "text":
		case "badge":
			return component.text
		case "copyButton":
		case "copyField":
			return `${component.value} ${component.tooltip ?? ""}`
		case "linkButton":
			return `${component.label} ${component.url}`
		case "actionButton":
			return component.label
		case "row":
			return [...component.left, ...component.right].map(searchTextOf).join(" ")
		case "spacer":
		case "divider":
			return ""
	}
}

export function componentMatchesSearch(
	component: SidebarSectionComponent,
	query: string,
): boolean {
	return searchTextOf(component).toLowerCase().includes(query.toLowerCase())
}

// Spacers and dividers only earn their space next to the fields they separate.
export function filterComponentsBySearch(
	components: readonly SidebarSectionComponent[],
	query: string,
): SidebarSectionComponent[] {
	if (!query.trim()) return [...components]
	return components.filter(
		(component) =>
			component.type !== "spacer" &&
			component.type !== "divider" &&
			componentMatchesSearch(component, query),
	)
}

export function sectionMatchesSearch(
	title: string,
	components: readonly SidebarSectionComponent[] | undefined,
	query: string,
): boolean {
	if (!query.trim()) return true
	if (title.toLowerCase().includes(query.toLowerCase())) return true
	if (!components) return false
	return components.some((component) =>
		componentMatchesSearch(component, query),
	)
}
